import { ActionService } from 'dashboard-services/services';

export default (() => {

  const CHANGE_VALUE = 'CHANGE_VALUE_NCSV_CREATOR'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  const STEPS = {
    DATE: "Date",
    SYMBOLS: "Symbols",
    COLUMNS: "Columns",
    VALIDATE: "Validate"
  }

  return {
    changeValue,
    CHANGE_VALUE,
    STEPS
  }
})()